module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/mobile/svg/vip_smalldiamond_normal-147fc2.svg";